<section class="inventory-page parent-container">
  <app-service-top-header
    [activeServices]="activeServices$ | async"
    [services]="services$ | async"
  ></app-service-top-header>

  <div class="inventory-view">
    <app-inventory-list
      #inventoryList
      [services]="services$ | async"
      [isLoading]="isLoading$ | async"
      [isLoaded]="isLoaded$ | async"
      [selectedService]="selectedService$ | async"
      [activeServices]="activeServices$ | async"
      [groupedServices]="groupFilteredServices$ | async"
      [browserSize]="browserSize$ | async"
      [isServicesInProgress]="isServicesInProgress$ | async"
      [locationsFilterOptions]="locationsFilterOptions$ | async"
      [serviceFilterOptions]="serviceFilterOptions$ | async"
      [statusFilterOptions]="statusFilterOptions$ | async"
      [totalSelectedFilters]="totalSelectedFilters$ | async"
      (setSelectedService)="onSetSelectedService($event)"
      (setLoadingIndicator)="onLoadingIndicator()"
      [locationsFilterFormControl]="locationsFilterFormControl"
      [serviceFilterFormControl]="serviceFilterFormControl"
      [statusFilterFormControl]="statusFilterFormControl"
      [groupByFormControl]="groupByFormControl"
      [isAscFormControl]="isAscFormControl"
      [searchTermControl]="searchTermControl"
    ></app-inventory-list>

    @if ((browserSize$ | async) !== 'small') {
      <app-inventory-detail
        [browserSize]="browserSize$ | async"
        [services]="services$ | async"
        [selectedService]="selectedService$ | async"
        [activeServices]="activeServices$ | async"
      ></app-inventory-detail>
    }
  </div>
</section>

